import {IconButton} from "./IconButton";
import {AddressBookIcon} from "../utils/icons";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {Flex} from "./Container/Flex";
import {Comment, fontSize, Text} from "../utils/style/texts";
import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {createStructuredSelector} from "reselect";
import {selectContacts} from "../redux/selectors/contact.selector";
import {compose} from "redux";
import {connect} from "react-redux";
import {selectDevices} from "../redux/selectors/device.selector";
import Checkbox from "./Controls/Checkbox";
import TextButton from "./Controls/TextButton";


const SelectContactButton = props => {
    const [anchor, setAnchor] = React.useState();
    const [selectedIds, setSelectedIds] = React.useState(new Set());
    const [t] = useTranslation();

    const {
        contacts,
        devices,
        subtitle,
        onContactSelected,
        onContactsSelected,
        onDeviceSelected,
        multiSelect,
        selectedContactIds,
        deviceFilter,
        style
    } = props;

    const handleOpen = e => {
        if (multiSelect && selectedContactIds) {
            setSelectedIds(new Set(selectedContactIds));
        } else {
            setSelectedIds(new Set());
        }
        setAnchor(e.currentTarget);
    };

    const selectContact = contact => {
        setAnchor(null);
        onContactSelected(contact);
    };
    const selectDevice = device => {
        setAnchor(null);
        onDeviceSelected(device);
    };

    const toggleContact = contact => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            if (next.has(contact.id)) {
                next.delete(contact.id);
            } else {
                next.add(contact.id);
            }
            return next;
        });
    };

    const handleConfirm = () => {
        const sortedContacts = contacts.sortBy(c => c.name.lc()).filter(subtitle);
        const selected = sortedContacts.filter(c => selectedIds.has(c.id));
        if (onContactsSelected) onContactsSelected(selected.toArray ? selected.toArray() : [...selected]);
        setAnchor(null);
    };

    const handleClose = () => {
        setAnchor(null);
    };

    return (
        <div style={style}>
            <IconButton
                tooltip={t('selectFromAddressBook')}
                onClick={handleOpen}>
                <AddressBookIcon/>
            </IconButton>
            <Menu
                anchorEl={anchor}
                open={!!anchor}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top'
                }}
                onClose={handleClose}
            >
                {!!(onContactSelected || (multiSelect && onContactsSelected)) && [
                    <MenuItem disabled key="contacts">{t('contacts')}</MenuItem>,
                    ...contacts.sortBy(c => c.name.lc()).filter(subtitle).map(c => (
                        <StyledMenuItem
                            key={`c${c.id}`}
                            onClick={() => multiSelect ? toggleContact(c) : selectContact(c)}>
                            {multiSelect && (
                                <Checkbox
                                    checked={selectedIds.has(c.id)}
                                    style={{padding: 4, marginRight: 4}}
                                />
                            )}
                            <Flex col>
                                <Text>{c.name}</Text>
                                <Comment className="subtitle">{subtitle(c)}</Comment>
                            </Flex>
                        </StyledMenuItem>
                    ))
                ]}
                {!!onDeviceSelected && [
                    <MenuItem disabled key="devices">{t('devices')}</MenuItem>,
                    ...devices.sortBy(d => d.name.lc()).filter(d => d.phone && (!deviceFilter || deviceFilter(d))).map(d => (
                        <StyledMenuItem
                            key={`d${d.id}`}
                            onClick={() => selectDevice(d)}>
                            <Flex col>
                                <Text>{d.name}</Text>
                                <Comment className="subtitle">{subtitle(d)}</Comment>
                            </Flex>
                        </StyledMenuItem>
                    ))
                ]}
                {multiSelect && (
                    <ConfirmContainer>
                        <TextButton onClick={handleConfirm}>
                            {t('confirm')}
                        </TextButton>
                    </ConfirmContainer>
                )}
            </Menu>
        </div>
    );
};

const StyledMenuItem = styled(MenuItem)`
    .subtitle {
        font-size: ${fontSize.xs}pt !important;
    }
`;

const ConfirmContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 4px 8px;
    border-top: 1px solid #e0e0e0;
    position: sticky;
    bottom: 0;
    background: white;
`;

function mapDispatchToProps(_) {
    return {};
}

const mapStateToProps = createStructuredSelector({
    contacts: selectContacts(),
    devices: selectDevices()
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(SelectContactButton);